import { Flex } from "@chakra-ui/react";
import { PreferenceForm } from "@ui/application";
import { NotificationPreferencesDto } from "@ui/application/forms";
import { PropsWithChildren } from "react";

export interface NotificationSettingsProps extends PropsWithChildren<unknown> {
  preferences: NotificationPreferencesDto;
  onSubmit: (preferences: NotificationPreferencesDto) => void;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
}

export const NotificationSettings = (props: NotificationSettingsProps) => {
  const { preferences, onSubmit, isLoading, isError, isSuccess } = props;
  const handleSubmit = (newPreferences: NotificationPreferencesDto) =>
    onSubmit(newPreferences);

  return (
    <Flex
      direction="column"
      bg="white"
      borderRadius="xl"
      boxShadow="md"
      p="10"
      alignItems="center"
    >
      <PreferenceForm
        {...{
          preferences,
          onSubmit: handleSubmit,
          isLoading,
          isError,
          isSuccess,
        }}
      />
    </Flex>
  );
};
